








import { BaseSelect, selectName } from '#components/baseSelect';

import {
	NAME,
	// eslint-disable-next-line no-unused-vars
	PPalivoEnum,
} from '../constants';

type BaseMapperData = {
	ZAZNAM_ID: number;
	TEXT: string;
	TYPKOD: string;
	DDP: string;
	VERZE_MK_ZKT: string;
	DOPLNEK_MK_ZKT: string;
	PC: number;
	MODEL_ROK: string;
	PLATNOST_DAT: Date;
	VYBAVA_VAZBA: string;
	PALIVO_PZN: PPalivoEnum;
	VYROBEKVOZ_OZN: string;
	TABLPOZICE: string;
	VYKON: number;
	OBJEM: number;
};

type RequestedData = {
	isClear: boolean;
	value: number | null;
	text: string | null;
	typkod: string | null;
	ddp: string | null;
	verzeMk: string | null;
	doplnekMk: string | null;
	pc: number | null;
	modelRok: string | null;
	platnostDat: Date | null;
	vybavaVazba: string | null;
	palivoPzn: PPalivoEnum | null;
	vyrobekvozOzn: string | null;
	tablpozice: string | null;
	vykon: number | null;
	objem: number | null;
};

type Data = {
	storeObject: string,
	emptyObject: RequestedData,
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'NAME' },
		showLabel: { type: Boolean, default: true },
		modelrok: { type: String },
		doplnekmk: { type: Number },
	},
	data(): Data {
		return {
			storeObject: NAME,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				typkod: null,
				ddp: null,
				verzeMk: null,
				doplnekMk: null,
				pc: null,
				modelRok: null,
				platnostDat: null,
				vybavaVazba: null,
				palivoPzn: null,
				vyrobekvozOzn: null,
				tablpozice: null,
				vykon: null,
				objem: null,
			},
		};
	},
	computed: {
		modelrokCmp: {
			get() {
				return this.modelrok;
			},
			set(val) {
				this.$emit('update:modelrok', val);
			},
		},
	},
	methods: {
		dbToBaseMapper(data: BaseMapperData) {
			return {
				value: data.ZAZNAM_ID,
				text: data.TEXT,
				typkod: data.TYPKOD,
				ddp: data.DDP,
				verzeMk: data.VERZE_MK_ZKT,
				doplnekMk: data.DOPLNEK_MK_ZKT,
				pc: data.PC,
				modelRok: data.MODEL_ROK,
				platnostDat: data.PLATNOST_DAT,
				vybavaVazba: data.VYBAVA_VAZBA,
				palivoPzn: data.PALIVO_PZN,
				vyrobekvozOzn: data.VYROBEKVOZ_OZN,
				tablpozice: data.TABLPOZICE,
				vykon: data.VYKON,
				objem: data.OBJEM,
			};
		},
	},
});
